import React, {Component} from 'react'
import TableComp from '../../../../components/_utils/table'
import PageHeaderWrapper from '../../../../components/PageHeaderWrapper'
import {RightsWrapper} from '../../../../components/_utils/utils'

import { Link } from "react-router-dom";

import moment from 'moment'
import {Button, Card, notification, Popconfirm, Tooltip, Row, Col} from 'antd'
import Request from '../../../../request'

import {connect} from 'react-redux'
import styles from '../../country/all/styles.less'
import commonStyle from '../../../common.less'

// const TabPane = Tabs.TabPane
// const Option = Select.Option

class AllLevel extends Component {
    state = {count: 0, arr: [], list: [], loadList: false, localUser:{}}

    constructor(props) {
        super(props)

        this.table = React.createRef()
    }

    apiRequest = params => {
        return new Promise(async resolve => {
            // params.count = 200
            params.sortField = 'levelName'
            params.sortOrder = !params.sortOrder ? 'ascend' : params.sortOrder
            let data = await Request.loadLevels({
                ...params,
                regExFilters: ['levelName']
            })
            this.setState({count: data.total})
            resolve(data)
        })
    }

    handleDelete = (levelId) => {
        Request.deleteLevel({_id: levelId})
            .then(x => {

                if (x.success) {
                    notification.success({
                        message: x.msg,
                        description: x.msg
                    })
                } else {
                    notification.error({
                        message: 'Error',
                        description: x.msg
                    })
                }
                this.table.current.reload()
            })
            .catch(err => {
                notification.error({
                    message: 'Error',
                    description: 'Some Error'
                })
            })
    }

    componentDidMount() {
        let localUser = JSON.parse(localStorage.getItem('user'))
        this.setState({localUser})
    }

    render() {  
        const columns = [
            {
                title: 'Level Name',
                key: 'levelName',
                dataIndex: 'levelName',
                sorter: true,
                searchTextName: 'levelName',
                filterRegex: true
            },

            {
                title: 'Last Updated By',
                key: 'lastUpdatedByName',

                dataIndex: 'lastUpdatedByName',
                render: (text, record) => {
                    return (
                        <div>
                            <div className={commonStyle.user}>
                                {text} {record.lastUpdate}
                            </div>

                            <small>{moment(record.time).fromNow()}</small>
                        </div>
                    )
                }
            },
            {
                title: 'Action',
                key: 'operation',
                render: (text, record) => (
                    <React.Fragment>
                        {record.businessId === this.state.localUser.businessId?
                        <RightsWrapper myRight={'Level.edit'}>
                            <Tooltip title="Edit Details">
                                <Button
                                    className={styles.btn}
                                    shape="circle"
                                    href={`/master/edit-level?id=${record._id}`}
                                    icon="edit"
                                />
                            </Tooltip>
                            <Tooltip title="Delete Level">
                                <Popconfirm
                                    title="Are you sure to delete Level?"
                                    onConfirm={() => this.handleDelete(record._id)}
                                    okText="Yes"
                                    cancelText="No">
                                    <Button
                                        shape="circle"
                                        className={styles.btn}
                                        icon="delete"/>
                                </Popconfirm>
                            </Tooltip>
                        </RightsWrapper>
                        :null }
                    </React.Fragment>
                )
            }
        ]
        return (
            <PageHeaderWrapper title={`Levels ${this.state.count} `}>
                <Card style={{ marginBottom: 10 }}>
                    <Row>
                        <Col span={12}>
                        </Col>
                        <Col span={10}>
                        </Col>
                        <Col span={2}>
                            <div style={{textAlign: 'right', marginTop: '15px'}}>
                                <Link to='/master/add-level'><Button>Add</Button></Link>
                            </div>
                        </Col>
                    </Row>
                </Card>
                <Card bordered={true}>
                    <TableComp
                        columns={columns}
                        apiRequest={this.apiRequest}
                        ref={this.table}/>
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({global}) => ({
    categories: global.categories
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AllLevel)
